<template>
    <div>
        <div class="form-horizontal" enctype="multipart/form-data" @submit.prevent="store" @keydown="form.errors.clear($event.target.name)">
            <table class="table table-striped">
                <tr>
                   <th>{{ uLang('app.name') }}</th>
                   <th>{{ uLang('app.action') }}</th>
                </tr>
                <tr v-for="welfare in welfares">
                    <td>
                        <input type="text" v-if="welfare.editable" class="form-control" :name="welfare.value" v-model="form['value'][welfare.id]">
                        <span v-if="!welfare.editable">{{ welfare.value }}</span>
                    </td>
                    <td>
                        <a href="#" @click.prevent="removeWelfare(welfare)" class="btn btn-danger" v-if="welfare.deleteable" :title="uLang('app.delete_welfare')">
                            <i class="fa fa-trash"></i>
                        </a>
                    </td>
                </tr>
            </table>

            <div class="form-group">
                <div class="input-group">
                    <input type="text" class="form-control" name="new" v-model="newWelfare" :placeholder="uLang('app.create_entity', { entity: lang('app.welfare')})" :title="uLang('app.add_new_welfare')">
                    <span class="input-group-btn">
                        <button type="button" class="btn btn-success" @click="addWelfare" :disabled="form.busy">{{ uLang('app.create_entity', { entity: lang('app.welfare')}) }}</button>
                    </span>
                </div>
            </div>

            <div class="form-group">
                <input :disabled="form.busy" type="button" :value="uLang('app.save_setting')" @click="store()" class="btn btn-brand" />
            </div>
        </div>
    </div>
</template>

<script>
    import Form from '~/Form/Form'
    import { ErrorAlert, SuccessAlert, DestroyAlert } from '~/Swals'

    export default {
        name: 'Welfares',
        props: {
            settingId: {
                required: true,
            },
        },
        data() {
            return {
                form: new Form({
                    value: {},
                }),
                newWelfare: '',
                welfares: []
            }
        },
        mounted: function () {
            this.retrieveValues();
        },
        methods: {
            async store() {
                this.form['patch']('/api/admin/settings/' + this.settingId)
                    .then(response => {
                        this.setValues(response);
                        new SuccessAlert({ text: this.uLang('app.entity_updated', { entity: lang('app.welfares')})}).show();
                    })
                    .catch(error => {
                        new ErrorAlert({
                            title: uLang('app.oops_something_went_wrong'),
                            text: uLang('app.all_inputs_need_to_be_filled'),
                        }).show();
                    });
            },

            setValues(data) {
                this.form.value = {};

                this.welfares = data;

                data.forEach(function (welfare){
                    if(welfare.editable){
                        this.value[welfare.id] = welfare.value;
                    }

                }, this.form);

            },

            async retrieveValues() {
                const { data } = await window.axios.get('/api/admin/settings/' + this.settingId + '/values');

                this.setValues(data);
            },

            addWelfare() {
                if (this.newWelfare === '')
                    return;

                this.welfares.push(
                    {
                        id: this.newWelfare,
                        value: this.newWelfare,
                        deleteable: 1,
                        editable: 1
                    }
                );
                this.form.value[this.newWelfare] = this.newWelfare;
                this.newWelfare = '';
            },

            removeWelfare(welfare) {
                new DestroyAlert({
                    text: this.lang('app.delete_warning_entity', { entity: this.lang('app.welfare') })
                }).show().then(async () => {
                    delete this.form.value[welfare.id];

                    //remove the welfare from the table
                    this.welfares = this.welfares.filter(function (current_welfare) {
                        return current_welfare.value != welfare.value;
                    });
                })
            }
        }
    }
</script>

<style lang="css" scoped>

</style>